import {
  fieldCalendarReturnToOrFallback,
  safeFieldCalendarReturnTo,
} from "@/components/field-calendar/fieldCalendarUrlState";

const SESSION_EXACT = ["/tasks", "/my-tasks", "/calendar", "/calendar/field"] as const;

export type SvrBackTarget = {
  path: string | null;
  label: string;
  useHistory: boolean;
  clearSessionReferrer: boolean;
};

export function svrBackLabelForPath(path: string): string {
  const pathname = path.split("?")[0] ?? path;
  if (pathname === "/site-visits" || pathname.startsWith("/site-visits/")) return "Back to Site Visits";
  if (pathname === "/tasks") return "Back to Tasks";
  if (pathname === "/my-tasks") return "Back to My Tasks";
  if (pathname === "/calendar") return "Back to Calendar";
  if (pathname.startsWith("/calendar/field")) return "Back to Field Calendar";
  return "Back";
}

export function resolveSvrBackTarget(input: {
  returnTo: string | null;
  historyFrom?: string | null;
  sessionReferrer?: string | null;
  historyLength: number;
}): SvrBackTarget {
  if (input.returnTo != null && input.returnTo.length > 0) {
    const path = fieldCalendarReturnToOrFallback(input.returnTo);
    return {
      path,
      label: svrBackLabelForPath(path),
      useHistory: false,
      clearSessionReferrer: false,
    };
  }

  const fromState = safeFieldCalendarReturnTo(input.historyFrom);
  if (fromState) {
    return {
      path: fromState,
      label: svrBackLabelForPath(fromState),
      useHistory: false,
      clearSessionReferrer: false,
    };
  }

  const ref = input.sessionReferrer;
  if (ref && (SESSION_EXACT as readonly string[]).includes(ref)) {
    return {
      path: ref,
      label: svrBackLabelForPath(ref),
      useHistory: false,
      clearSessionReferrer: true,
    };
  }
  const refSafe = safeFieldCalendarReturnTo(ref);
  if (refSafe?.startsWith("/calendar/field")) {
    return {
      path: refSafe,
      label: svrBackLabelForPath(refSafe),
      useHistory: false,
      clearSessionReferrer: true,
    };
  }

  if (input.historyLength > 1) {
    return { path: null, label: "Back", useHistory: true, clearSessionReferrer: false };
  }

  return {
    path: "/site-visits",
    label: "Back to Site Visits",
    useHistory: false,
    clearSessionReferrer: false,
  };
}
